import { LitElement, html, css, svg } from "lit";
import { customElement } from "lit/decorators.js";

import "./feather-icon.js";

@customElement("auto-nav")
export class AutoNav extends LitElement {
  static properties = {
    home: { type: String },
    settings: { type: String },
    about: { type: String },
  };

  static styles = css`
    nav {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      background: #ccc;
      color: #eee;
      border-top: 1px solid #999;
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    }

    nav ul {
      width: 100%;
      margin: 0;
      padding: 10px;
      text-align: center;
    }

    nav li {
      list-style-type: none;
      display: inline-block;
      margin: 0 16px;
    }

    nav a:link {
      color: #369;
      text-decoration: none;
    }

    nav a:visited {
      color: #369;
    }

    nav a:hover {
      color: #fff;
      text-decoration: underline;
    }

    nav a:active {
      color: #fff;
    }
  `;

  render() {
    return html`
      <nav>
        <ul>
          <li>
            <a href="#">
              <feather-icon icon="home"></feather-icon>
            </a>
          </li>
          <li>
            <a href="#settings">
              <feather-icon icon="settings"></feather-icon>
            </a>
          </li>
          <li>
            <a href="#about">
              <feather-icon icon="info"></feather-icon>
            </a>
          </li>
        </ul>
      </nav>
    `;
  }
}
